import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Typography } from "antd";
import { fetchLocationsList } from "./locationsThunks";
import LocationList from "./components/LocationList";

const { Title } = Typography;

const Locations = () => {
  const dispatch = useDispatch();
  const { locations } = useSelector((state) => state.locations);

  useEffect(() => {
    dispatch(fetchLocationsList());
  }, [dispatch]);

  return (
    <>
      <Title level={2}>Locations</Title>
      <LocationList locationsList={locations} />
    </>
  );
};

export default Locations;
